import { Suspense } from 'react'
import { Routes, Route, NavLink } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { AnimatePresence, motion } from 'framer-motion'
import { useLocation } from 'react-router-dom'
import { useTheme } from './hooks/useTheme'
import Home from './pages/Home'
import About from './pages/About'
import Matcha from './pages/Matcha'
import Caviar from './pages/Caviar'
import Contact from './pages/Contact'

function LangSwitcher() {
  const { i18n } = useTranslation()
  const langs = ['en','fr','ja','ar','es']
  return (
    <div className="lang-switcher" aria-label="Language">
      {langs.map(l => (
        <button key={l} onClick={() => i18n.changeLanguage(l)} aria-current={i18n.language.startsWith(l) || undefined}>
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  )
}

function ThemeToggle() {
  const { theme, toggleTheme } = useTheme()
  return (
    <button className="theme-toggle" onClick={toggleTheme} aria-label="Toggle theme">
      {theme === 'dark' ? 'Light' : 'Dark'}
    </button>
  )
}

export default function App() {
  const { t, i18n } = useTranslation()
  const location = useLocation()
  return (
    <div dir={i18n.dir()}>
      <Helmet>
        <html lang={i18n.language} />
        <title>Pearl of Galia — Contemporary Luxury Distribution</title>
        <meta name="description" content="Pearl of Galia (Paris) — contemporary luxury distribution: finest Japanese matcha and rare caviar." />
      </Helmet>

      <header className="site-nav-modern" aria-label="Primary">
        <div className="nav-container">
          <NavLink to="/" className="nav-logo">
            <span>{t('brand.name')}</span>
          </NavLink>
          <nav className="nav-menu">
            <ul>
              <li><NavLink to="/about" className="nav-link">{t('nav.about')}</NavLink></li>
              <li><NavLink to="/matcha" className="nav-link">{t('nav.matcha')}</NavLink></li>
              <li><NavLink to="/caviar" className="nav-link">{t('nav.caviar')}</NavLink></li>
              <li><NavLink to="/contact#contact-form" className="nav-link">{t('nav.contact')}</NavLink></li>
            </ul>
          </nav>
          <div className="nav-controls">
            <LangSwitcher />
            <ThemeToggle />
          </div>
        </div>
      </header>

      <Suspense fallback={<div className="loading" />}> 
        <AnimatePresence mode="wait">
          <motion.main key={location.pathname}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.35, ease: 'easeOut' }}
          >
            <Routes location={location}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/matcha" element={<Matcha />} />
              <Route path="/caviar" element={<Caviar />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </motion.main>
        </AnimatePresence>
      </Suspense>
    </div>
  )
}
